<template>
  <div class="zhaosheng">
    <div class="banner">
      <div class="banner-center center">
        <div class="banner-info">
          <div class="btn shenqing" @click="openDialog('免费试用', 0)">
            申请试用
          </div>
        </div>
      </div>
    </div>
    <div class="item_1 center">
      <div class="item-title">
        <h3 class="title1 textAleft">易知独秀</h3>
        <h4 class="title2 textAleft">海量好玩有趣招生模板一键生成</h4>
      </div>
      <div class="item-contents">
        <ul class="nav-top clearfix">
          <li
            v-for="(x, index) in item1_list"
            :class="{ actived: isHover == index }"
            @mouseenter="hovernav(x, index)"
          >
            <img
              :src="
                '/static/img/product_zhaosheng/chanpin2_0' +
                  (index + 1) +
                  '.png'
              "
              alt=""
            />
            <div class="title">{{ x.title }}</div>
          </li>
        </ul>
        <div class="item-info clearfix">
          <div class="item-info-left fl textAleft">
            <img
              :src="
                '/static/img/product_zhaosheng/chanpin2_' +
                  (isHover + 1) +
                  '_' +
                  (isHover + 1) +
                  '.png'
              "
              alt=""
            />
            <div class="intro">
              <div class="title textAleft">{{ itemsHover.title }}</div>
              <p class="textAleft">{{ itemsHover.info1 }}</p>
              <p class="textAleft">{{ itemsHover.info2 }}</p>
            </div>
          </div>
          <div class="item-info-right fr">
            <img
              :src="
                '/static/img/product_zhaosheng/chanpin2_' +
                  (isHover + 1) +
                  '.png'
              "
              alt=""
            />
          </div>
        </div>
        <div class="item-contents">
          <ul>
            <li
              v-for="(x, index) in contents"
              class="clearfix"
              :class="{ odd: index % 2 }"
            >
              <div class="image">
                <img
                  :src="
                    '/static/img/product_zhaosheng/chanpin2_chahua_0' +
                      (index + 1) +
                      '.png'
                  "
                  alt=""
                />
              </div>
              <div class="info">
                <div class="title fz40">{{ x.title }}</div>
                <p class="fz18">{{ x.p1 }}</p>
                <p class="fz18">{{ x.p2 }}</p>
                <p class="fz18">{{ x.p3 }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <shen-qing></shen-qing>
  </div>
</template>

<script>
import shenQing from "./shenqing.vue";
export default {
  components: {
    shenQing
  },
  data() {
    return {
      isHover: 0,
      itemsHover: {
        title: "微传单",
        info1: "传播快，范围广，互动性强",
        info2: "操作简单易上手"
      },
      item1_list: [
        { title: "微传单", info: "操作简单易上手", info2: "操作简单易上手" },
        {
          title: "砍价",
          info1: "老带新裂变拓客",
          info2: "精准获取有效学员信息"
        },
        { title: "助力", info1: "引爆学员自发分享", info2: "轻松触达目标客群" },
        {
          title: "拼团",
          info1: "趣味营销",
          info2: "刺激学员分享和邀请好友参与"
        },
        {
          title: "抢购",
          info1: "快速获取精准目标学员",
          info2: "轻松引爆朋友圈"
        }
      ],
      contents: [
        {
          title: "微官网",
          p1: "搭建线上平台",
          p2: "实现品牌推广和课程销售",
          p3: "提高机构线上获客能力"
        },
        {
          title: "电子优惠券",
          p1: "自定义设置优惠活动",
          p2: "支持家长自主传播分享",
          p3: "机构营销能力显著提升"
        },
        {
          title: "转介绍管理",
          p1: "通过佣金激励老学员裂变传播",
          p2: "玩转老带新 ",
          p3: "实现爆发性招生增长"
        },
        {
          title: "学员CRM",
          p1: "层层筛选客户名单",
          p2: "实时掌握潜客跟进状态 ",
          p3: "有效提高签单率"
        }
      ]
    };
  },
  created() {},
  mounted() {},
  methods: {
    hovernav(x, ind) {
      this.isHover = ind;
      this.itemsHover = {
        title: x.title,
        info1: x.info1,
        info2: x.info2
      };
    },
    openDialog: function(title, type) {
      //type:(0机构,1微官网)
      this.$parent.$refs.openPop.openDialog(title, type);
    }
  }
};
</script>

<style scoped lang="less">
.banner {
  width: 100%;
  height: 480px;
  margin-top: 80px;
  background: url("https://cdntest.yizhiniao.com/newWebsite_/product_zhaosheng/chanpin2_banner_801_1.png")
    no-repeat center;
  background-size: cover;
  .banner-center {
    height: 100%;
    position: relative;
  }

  .banner-info {
    position: absolute;
    bottom: 120px;
    left: 60px;
    text-align: left;
  }
  .shenqing {
    border: none;
    color: #ff7f0d;
    &:hover,
    &:active {
      background: #ff7f0d;
      color: #fff;
    }
  }
}
.item_1 {
  padding-top: 180px;
  padding-bottom: 180px;
  .item-contents {
    margin-top: 80px;
    .nav-top {
      /* display: flex;
            justify-content: space-between; */
      margin-bottom: 40px;
      > li {
        width: 100px;
        /* height:118px; */
        margin-right: 76px;
        float: left;
        img {
          width: 70px;
          height: 70px;
          margin: 0 auto 4px;
        }
        .title {
          text-align: center;
          color: #4a4a4a;
          font-size: 20px;
          line-height: 28px;
          position: relative;
        }
        &.actived {
          .title {
            color: #1e1e1e;
            font-size: 22px;
            line-height: 30px;
            padding-bottom: 18px;
            &:after {
              content: "";
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 4px;
              background: #1e1e1e;
              border-radius: 4px;
            }
          }
        }
      }
    }
    .item-info {
      .item-info-left {
        margin-left: 60px;
        img {
          width: 130px;
          height: 130px;
          margin-top: 100px;
        }
        .intro {
          margin-top: -55px;
          margin-left: 81px;
          .title {
            margin-bottom: 25px;
            font-size: 18px;
            font-weight: 500;
            color: #1e1e1e;
            line-height: 25px;
          }
          p {
            font-size: 18px;
            font-weight: 400;
            color: #646464;
            line-height: 25px;
          }
        }
      }
      .item-info-right {
        width: 660px;
        height: 420px;
      }
    }
    .item-contents {
      ul {
        li {
          .image {
            width: 720px;
            height: 420px;
            float: left;
          }
          .info {
            float: right;
            margin-right: 100px;
            .title {
              margin-top: 40px;
              margin-bottom: 40px;
              color: #1e1e1e;
              text-align: right;
            }
            p {
              color: #646464;
              text-align: right;
            }
          }
          &.odd {
            .image {
              float: right;
            }
            .info {
              float: left;
              margin-left: 100px;
              .title {
                text-align: left;
              }
              p {
                text-align: left;
              }
            }
          }
          &:not(:first-child) {
            margin-top: 200px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product_zhaosheng.vue